const usernamePrompt = "Hi,%0A%0AI am {USERNAME}";
const problemPrompt = "Describe your problem.";

export const contactEmailLink = `mailto:hello@RentBabe.com?subject=Support Request&body=${usernamePrompt}%0A${problemPrompt}%0A%0A`